'use strict';

angular.module('TurneroApp').component('coRecepcionTurnosSacar', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ciudadanoSeleccionado: '<',
        validate: '<'
    },
    controller: [
        'turnosService', '$rootScope', '$scope', 'utilsService', 'TurneroAppConstant', 'agendaService', 'signalrDotNetCoreService', '$filter', '$interval',
        function (turnosService, $rootScope, $scope, utilsService, TurneroAppConstant, agendaService, signalrServiceExterno, $filter, $interval) {
            var ctrl = this;
            ctrl.prioridad = TurneroAppConstant.Prioridad_Ley;
            ctrl.Turno = {}
            ctrl.Aguarde = {};
            ctrl.limpiarVariables = function () {
                ctrl.Aguarde = {};
                ctrl.mostrar = {
                    Prioridades: false,
                    Tramites: false,
                    NoHayTurnos: false,
                    Agendas: false,
                    Turno_Anunciado: false,
                    DNI_Inexistente: false,
                    Sacar: false
                }
                ctrl.filter = {
                    limit: 4,
                    page: 1,
                }
                ctrl.total = 0
            }

            $scope.$on('limpiarRecepcion', function (event, bool) {
                ctrl.limpiarVariables();
                ctrl.Turno = {}
                ctrl.Aguarde = {};
            });

            ctrl.$onChanges = function () {
                ctrl.limpiarVariables();
                if (ctrl.centroAtencionSeleccionado) {
                    if (ctrl.ciudadanoSeleccionado) {
                        ctrl.Aguarde.Agendas = true;
                        agendaService.Recepcion_Agendas_Get({ 'Id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id }).$promise.then(function (resultado) {
                            if (resultado.Data.length > 0) {
                                ctrl.Agendas = resultado.Data;
                                ctrl.limpiarVariables();
                                ctrl.mostrar.Agendas = true
                            } else {
                                ctrl.limpiarVariables();
                                ctrl.mostrar.NoHayTurnos = true;
                            }

                        }).catch(function (error) {
                            utilsService.errores(error);
                        });
                    } else {
                        ctrl.limpiarVariables();
                        ctrl.mostrar.DNI_Inexistente = true
                    }

                }

            }

            ctrl.paginarTramites = function () {
                ctrl.TramitesOnScreen = [];
                if (ctrl.Tramites.length > 0) {
                    ctrl.calc = (ctrl.filter.page - 1) * ctrl.filter.limit
                    for (var i = ctrl.calc; i < ctrl.Tramites.length; i++) {
                        if (i < (ctrl.filter.limit * ctrl.filter.page))
                            ctrl.TramitesOnScreen.push(ctrl.Tramites[i]);
                    }
                }

            }

            ctrl.seleccionarAgenda = function (agenda) {
                if (agenda) {
                    ctrl.Turno.Agenda = agenda;
                    ctrl.Aguarde.Agendas = true;
                    ctrl.Aguarde.Tramites = true;

                    agendaService.Recepcion_Get_Tramites({ 'id_agenda': agenda.id }).$promise.then(function (resultado) {
                        ctrl.Agenda = resultado.Data;

                        if (ctrl.Agenda.Es_Agenda_Suac == 'N') {
                            ctrl.total = Math.ceil(resultado.Data.Tramites_Agenda.length / ctrl.filter.limit);
                            ctrl.generarPaginas(ctrl.total);
                            ctrl.Tramites = resultado.Data.Tramites_Agenda;
                            ctrl.paginarTramites();
                            ctrl.limpiarVariables();
                            ctrl.mostrar.Tramites = true;
                        } else {
                            ctrl.limpiarVariables();
                            ctrl.mostrar.Prioridades = true;
                        }

                    }).catch(function (error) {
                        utilsService.errores(error);
                    });
                }
            }

            ctrl.setPrioridad = function (tipo) {
                ctrl.Turno.Prioridad_Ley = tipo;
                ctrl.generandoTurno = true;
                var filtro = {
                    Id_Tramite_Relevado: ctrl.Turno.Tramite && ctrl.Turno.Tramite.Id_Tramite_Relevado ? ctrl.Turno.Tramite.Id_Tramite_Relevado : 0
                    , Id_Agenda: ctrl.Turno.Agenda.id
                    //, Id_Sexo: ctrl.ciudadanoSeleccionado.Datos_RegistroCivil.Id_Sexo
                    , N_Usuario_Cidi: ctrl.ciudadanoSeleccionado.Datos_Cidi.N_Ciudadano_Cidi
                    , Nro_Documento: ctrl.ciudadanoSeleccionado.Datos_RegistroCivil == null ? null : ctrl.ciudadanoSeleccionado.Datos_RegistroCivil.Nro_Documento
                    //, Pai_Cod_Pais: ctrl.ciudadanoSeleccionado.Datos_RegistroCivil.Pai_Cod_Pais ? ctrl.ciudadanoSeleccionado.Datos_RegistroCivil.Pai_Cod_Pais : null
                    //, Id_Numero: ctrl.ciudadanoSeleccionado.Datos_RegistroCivil.Id_Numero
                }
                turnosService.Get_Sobreturno(filtro).$promise.then(function (result) {
                    //result.Data.Permite_Sobreturno: 
                    //              0= turnos normal
                    //              1= Sobreturnos
                    //              2= No puede dar turnos
                    //result.Data.Motivo: 
                    //              1= Máximo de turnos por día
                    //              2= fuera de horario
                    //              3= Máximo de turnos por persona
                    //              4= Máximo de turnos por trámite
                    if (result.Data.Permite_Sobreturno == 0) {
                        ctrl.PostOrdenDeLlegada();
                    } else if (result.Data.Motivo == 3) {
                        swal({
                            title: 'No puede sacar un nuevo turno',
                            text: 'Usted ya se encuentra anunciado en esta agenda',
                            type: 'warning',
                            confirmButtonText: 'Aceptar'
                        });
                        ctrl.generandoTurno = false;

                        ctrl.limpiarVariables();
                        ctrl.goHome();
                    } else {
                        swal({
                            title: 'No hay más turnos disponibles',
                            text: 'Si necesita más información, acérquese al mostrador más cercano para que un agente le asesore',
                            type: 'warning',
                            confirmButtonText: 'Aceptar'
                        });
                        ctrl.generandoTurno = false;

                        ctrl.limpiarVariables();
                        ctrl.goHome();
                    }
                }).catch(function (error) {
                    ctrl.generandoTurno = false;
                    utilsService.errores(error);
                });
            }

            ctrl.generarPaginas = function (total) {
                ctrl.array = [];
                for (var i = 0; i < total; i++) {
                    ctrl.array.push(i + 1)
                }
            }


            ctrl.seleccionarTramite = function (tramite) {
                if (tramite) {
                    ctrl.Turno.Tramite = tramite
                    ctrl.limpiarVariables();
                    ctrl.mostrar.Prioridades = true
                }
            }

            ctrl.PostOrdenDeLlegada = function () {
                // VALIDACION: evitar enviar Id_Centro_Atencion inválido (0/undefined)
                if (!ctrl.centroAtencionSeleccionado || !ctrl.centroAtencionSeleccionado.id || parseInt(ctrl.centroAtencionSeleccionado.id) === 0) {
                    console.error('PostOrdenDeLlegada abortado: centroAtencionSeleccionado.id inválido', ctrl.centroAtencionSeleccionado);
                    swal({
                        title: 'Error',
                        html: 'No se ha detectado un centro de atención válido. Refresque la pantalla y vuelva a intentarlo.',
                        type: 'error',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: "Ok",
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    });
                    return;
                }

                var Turno = {
                    Id_Tramite_Relevado: ctrl.Turno.Tramite && ctrl.Turno.Tramite.Id_Tramite_Relevado ? ctrl.Turno.Tramite.Id_Tramite_Relevado : 0,
                    Sujeto_Ley_9131: ctrl.Turno.Prioridad_Ley,
                    Id_Agenda: ctrl.Turno.Agenda.id,
                    Nro_Documento: ctrl.ciudadanoSeleccionado.Datos_RegistroCivil == null ? null : ctrl.ciudadanoSeleccionado.Datos_RegistroCivil.Nro_Documento,
                    N_Usuario_Cidi: ctrl.ciudadanoSeleccionado.Datos_Cidi.N_Ciudadano_Cidi,
                    Id_Prioridad: ctrl.Turno.Prioridad_Ley != '' ? 1 : 0,
                    Id_Centro_Atencion: ctrl.centroAtencionSeleccionado.id
                }

                turnosService.Post_Turno_Orden_Llegada(Turno).$promise.then(function (resultado) {
                    console.info("Desde el backend se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + resultado.Data.id + ".");
                    //envio la notificacion hub
                    /*signalrServiceExterno.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                        //actualizo ese turno en atención
                        hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, resultado.Data.id).then(function () {
                            console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + resultado.Data.id + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + resultado.Data.id + ": " + err.toString());
                        });
                    });*/

                    ctrl.Turno.Solicitado = resultado.Data;
                    ctrl.imprimirTicket(resultado.Data);
                    swal.close();
                    ctrl.limpiarVariables();
                    ctrl.generandoTurno = false;
                    ctrl.mostrar.Turno_Anunciado = true;
                }).catch(function (error) {
                    ctrl.generandoTurno = false;
                    utilsService.errores(error);
                });
            }

            ctrl.goHome = function () {
                ctrl.limpiarVariables();
                $rootScope.$broadcast('GoHome', true);
            }

            ctrl.goBack = function () {
                $rootScope.$broadcast('sacarTurno', true);
            }

            ctrl.imprimirTicket = function (item) {
                turnosService.Get_Turno_Imprime_ticket({ 'Id_Turno': item.id }).$promise.then(function (resultado) {
                    if (resultado.Data == 'S') {
                        ctrl.configuracion = {
                            Id_Turno: item.id,
                            Modulo: 'RCP',
                            N_Equipo: ctrl.centroAtencionSeleccionado.id
                        }
                    }
                }).catch(function (error) {
                    utilsService.errores(error);

                })

            }

        }
    ],
    template: require('./recepcion_turnosSacar.html')
});



// WEBPACK FOOTER //
// ./app/components/recepcion/recepcion_turnosSacarComponent.js